export const TIPOS_TELEFONO = {
  TIPO_A: 'TIPO_A',
  TIPO_B: 'TIPO_B',
};

export const MODOS_TELEFONO = {
  NATIONAL: 'national',
  INTERNATIONAL: 'international',
};
